export default __webpack_public_path__ + "static/media/DSC_7917.ffedad39.jpg";